<form class="lv-artefact-container lv-component">
  <div class="lv-artefact Breite_Maximal">
    <div *ngIf="!!uiArtefakt.Werteliste" class="lv-radio-group-items">
      <ng-container *ngIf="managedFonds$ | async as allManagedFonds">
        <ng-container *ngIf="!uiArtefakt.Werteliste || !uiArtefakt.Werteliste.length">
          Es wurden im Core keine Fonds in diesem Produkt konfiguriert, daher wird nichts angezeigt.
        </ng-container>
        <div class="lv-gemanagte-portfolioloesung">
          <mat-radio-group [ngClass]="{'lv-material-segment-control': true,
                                         'lv-error-state': !!getError(),
                                         'lv-gemanagte-portfolioloesung-container': true}"
                           #radioGroup="ngModel"
                           [(ngModel)]="radiobuttonValue"
                           [required]="uiArtefakt.PflichtfeldJN"
                           [name]="controlName">
            <ng-container *ngFor="let fondsArray of allManagedFonds">
              <div class="lv-gemanagte-portfolioloesung-item">
                <!-- Radiobuttons mit genau einer Fondsgruppe -->
                <ng-container *ngIf="fondsArray.length === 1">
                  <div class="lv-gemanagte-portfolioloesung-item-wrapper">
                    <div class="lv-gemanagte-portfolioloesung-item-container">
                      <div class="lv-gemanagte-portfolioloesung-item-header">
                        <div>
                          <mat-radio-button
                              [value]="fondsArray[0].fondsgruppeId+''" [name]="fondsArray[0].fondsgruppeId+''"
                              (change)="changeRadiobuttonSelection(fondsArray[0])"
                              [checked]="(radiobuttonValue === '' + fondsArray[0].fondsgruppeId)">
                            <div>{{fondsArray[0].name}}</div>
                          </mat-radio-button>
                        </div>
                        <div class="lv-gemanagte-portfolioloesung-item-header-details">
                          <div class="lv-gemanagte-portfolioloesung-item-header-detail">Artikel {{fondsArray[0].portfolio?.esgEinstufungTvo}}</div>
                          <div class="lv-gemanagte-portfolioloesung-item-header-detail">SRI {{fondsArray[0].portfolio?.risikoklasse}}</div>
                        </div>
                      </div>
                      <div class="lv-gemanagte-portfolioloesung-item-row">{{fondsArray[0].portfolio?.beschreibung}}</div>
                    </div>
                  </div>
                  <lv-donut-chart [data]="fondsArray[0].fondsgruppeItems" [url]="fondsArray[0].portfolio?.url"></lv-donut-chart>
                </ng-container>
                <!-- Radiobuttons mit mehr als einer Fondsgruppe und integriertem Dropdown-->
                <ng-container *ngIf="fondsArray.length > 1">
                  <div class="lv-gemanagte-portfolioloesung-item-wrapper">
                    <div class="lv-gemanagte-portfolioloesung-item-container">
                      <div class="lv-gemanagte-portfolioloesung-item-header">
                        <div>
                          <mat-radio-button
                              [name]="model?.portfolio.portfolioCluster?.id"
                              (change)="changeRadiobuttonSelection(lastSelectedDropdownModel)"
                              [value]="model?.portfolio.portfolioCluster?.id"
                              [checked]="radiobuttonValue === model?.portfolio.portfolioCluster?.id">
                            <div>{{fondsArray[0].portfolio.portfolioCluster?.name}}</div>
                          </mat-radio-button>
                        </div>
                        <div class="lv-gemanagte-portfolioloesung-item-header-details">
                          <div class="lv-gemanagte-portfolioloesung-item-header-detail">Artikel {{fondsArray[0].portfolio?.esgEinstufungTvo}}</div>
                          <div class="lv-gemanagte-portfolioloesung-item-header-detail">SRI {{lastSelectedDropdownModel?.portfolio?.risikoklasse}}</div>
                        </div>
                      </div>
                      <div class="lv-gemanagte-portfolioloesung-item-row">{{lastSelectedDropdownModel?.portfolio?.beschreibung}}</div>
                      <ng-container *ngIf="fondsArray.length > 1">
                        <div class="lv-gemanagte-portfolioloesung-item-row">
                          <div>Aktiengewichtung</div>
                          <mat-form-field class="lv-material-form-input" color="accent">
                            <div class="lv-input-field">
                              <mat-select (valueChange)="changeDropdown($event)" [name]="fondsArray[0].portfolio.portfolioCluster?.id"
                                          [(ngModel)]="lastSelectedDropdownModel"
                                          [hideSingleSelectionIndicator]="true">
                                <mat-option *ngFor="let fondsitem of fondsArray"
                                            [value]="fondsitem.fondsgruppeId === lastSelectedDropdownModel.fondsgruppeId ? lastSelectedDropdownModel : fondsitem"
                                            class="lv-mat-option-multiline">
                                  {{fondsitem.portfolio.anlagestil}}
                                </mat-option>
                              </mat-select>
                            </div>
                          </mat-form-field>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <lv-donut-chart [data]="lastSelectedDropdownModel.fondsgruppeItems" [url]="lastSelectedDropdownModel?.portfolio?.url"></lv-donut-chart>
                </ng-container>
              </div>
            </ng-container>
          </mat-radio-group>
          <lv-infotext-permanent
              [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
          <input [name]="'lvHidden'" [(ngModel)]="radiobuttonValue" class="lv-gemanagte-portfolioloesung-hidden-form" [required]="true">
        </div>
      </ng-container>
    </div>
    <div>
      <mat-error class="lv-error-meldung-style" [ngClass]="uiArtefakt.BreiteInPixel"
                 *ngIf="getError() as error" (click)="onErrorClick()">
        <div class="lv-control-error"
             [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}">{{error}}</div>
      </mat-error>
    </div>
  </div>
</form>
